import { NoData } from "../../shared/components/noData";
export const Feedback = ({ feedback }) => {
  return (
    <div className="row mt-3">
      <div className="col-md-12">
        {feedback ? (
          <div
            dangerouslySetInnerHTML={{
              __html: feedback,
            }}
          ></div>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};
